import EuroSlashedIcon from 'assets/images/icons/EuroSlashed.svg?react';
import { Tooltip } from 'components/ui/tooltip';
import React from 'react';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations.ts';

interface OverdueInvoicesProps {
    className?: string;
    tooltipText?: string;
}

// With a tooltip the glyph is an image named by the tooltip's words, which a hover alone would keep from a screen
// reader and the keyboard; without one it is decoration.
const OverdueInvoices: React.FC<OverdueInvoicesProps> = ({ className, tooltipText }) => {
    const icon = (
        <span
            className={cn(
                'bg-error-light text-error inline-flex size-[23px] items-center justify-center rounded-[20%] p-[5px] text-[23px]',
                className
            )}
        >
            <EuroSlashedIcon
                role="img"
                aria-label={tooltipText ? t(tooltipText) : undefined}
                aria-hidden={tooltipText ? undefined : true}
                className="overdue-invoices-glyph size-full text-[red]"
            />
        </span>
    );

    if (!tooltipText) {
        return icon;
    }

    return (
        <Tooltip content={t(tooltipText)}>
            <span className="inline-flex">{icon}</span>
        </Tooltip>
    );
};

export default OverdueInvoices;
